export const isWindowUndefined = window => {
  if (typeof window === "undefined") {
    return true;
  } else {
    return false;
  }
};
